const ENPeriodType = {
	"Adicionar tipo de período": "Add period type",
	"Adicionar período":"Add period",
	"Alterar tipo de período": "Change period type",
	"Codigo do tipo de período é requerido":"Period type's code is required",
	"Datas do período":"Periods dates",
	"Data inicial do período é requerida":"Period's initial date is required",
	"Data inicial com data inválida":"Initial date is a invalid date",
	"Data final do período é requerida":"Period's final date is required",
	"Data final com data inválida":"Final date is a invalid date",
	"Deseja realmente excluir tipo de período": "Do you really want to delete the period type",
	"Erro ao adicionar tipo de período": "Error on adding period type",
	"Erro ao alterar tipo de período": "Error on changing period type",
	"Erro ao excluir tipo de período": "Error on deleting period type",
	"Exclusão do tipo de período": "Delete period type",
	"Excluir período":"Delete period",
	"Descrição do tipo de período é requerida": "Period type's description is required",
	"Tipos de Período":"Period types",
	"Tipos de período":"Period types",
	"Tipo de período adicionado com sucesso": "Period type successfully added",
	"Tipo de período alterado com sucesso": "Period type successfully changed",
	"Tipo de período excluído com sucesso": "Period type successfully deleted",
	"Codigo do período é requerido":"Period's code is required",
	"Descrição do período é requerida":"Period's description is required",
	"Novo tipo de período": "New period type"
};

export default ENPeriodType;
